<template>
  <div
    class="SwitchInput"
    :class="{ 'SwitchInput--isError': isError }"
  >
    <div
      v-if="label !== ''"
      class="SwitchInput-label p p-bold app-color-1 capitalize"
      :class="{
        required: required,
      }"
    >
      {{ label }}
    </div>

    <LineOptions
      v-model="internalCurrentOption"
      :options="options"
      :size="LINE_OPTIONS_SIZES.large"
      :color="isError ? LINE_OPTIONS_COLORS.error : LINE_OPTIONS_COLORS.default"
    />
    <div
      v-if="isError"
      class="text-truncate p isError"
    >
      {{ $t('main.enums.error.non-valid-data') }}
    </div>
  </div>
</template>

<script type="text/javascript">
  import mixinUi from '@/mixins/utils/ui.js'
  import mixinCurrency from '@/mixins/utils/currency.js'
  import mixinPhoneNumber from '@/mixins/utils/phoneNumber.js'
  import mixinStrFormat from '@/mixins/utils/strFormat.js'

  import { LINE_OPTIONS_SIZES, LINE_OPTIONS_COLORS } from '@/components/ui/common/LineOptions/LineOptions.const'
  import LineOptions from '@/components/ui/common/LineOptions/LineOptions'

  export default {
    components: {
      LineOptions,
    },
    mixins: [mixinUi, mixinCurrency, mixinPhoneNumber, mixinStrFormat,],
    props: {
      label: {
        type: String,
        default: '',
      },
      options: {
        type: Array,
        required: true,
      },
      value: {
        type: [String, Number, Boolean, null,],
        default: null,
      },
      required: {
        type: Boolean,
        default: false,
      },
      isError: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        LINE_OPTIONS_SIZES,
        LINE_OPTIONS_COLORS,
      }
    },
    computed: {
      internalCurrentOption: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
    },
  }
</script>

<style lang="scss">
.SwitchInput {
  .SwitchInput-label {
    margin-left: 8px;
    margin-bottom: 4px;
    &.required::after {
      content: '*';
    }
  }
  .isError {
    color: $color-ff524f;
  }
}
</style>
